import i18n from '../i18n';

const tourSteps = {
  en: {
    admin: [
      { target: '[data-testid="global-search"]', title: 'Quick Search', description: 'Search across students, staff, programs, and more from anywhere.', position: 'bottom' },
      { target: 'aside nav', title: 'Navigation Sidebar', description: 'Access all modules — organized by Overview, Training, Finance, and Compliance.', position: 'right' },
      { target: '[data-testid="help-fab"]', title: 'Page Help', description: 'Every page has a help button. Click it for step-by-step guidance.', position: 'left' },
      { target: '[data-testid="notification-bell"]', title: 'Notifications', description: 'System alerts, deadlines, and important events.', position: 'bottom' },
    ],
    finance: [
      { target: 'aside nav', title: 'Finance & Accounting', description: 'Start at Finance Home for cash, AR aging and AP due this week. The menu is grouped (Receivables, Payables, General Ledger, Tax & Zakat, Reports) — click a group heading to fold it.', position: 'right' },
      { target: '[data-testid="global-search"]', title: 'Quick Search', description: 'Search students, vendors, purchase orders from anywhere.', position: 'bottom' },
      { target: '[data-testid="help-fab"]', title: 'Page Help', description: 'Click for step-by-step instructions on any page.', position: 'left' },
    ],
    instructor: [
      { target: 'aside nav', title: 'Instructor Portal', description: 'Log flights, manage availability, and view flight requests.', position: 'right' },
      { target: '[data-testid="help-fab"]', title: 'Page Help', description: 'Click here anytime for help on the current page.', position: 'left' },
    ],
    student: [
      { target: 'aside nav', title: 'Student Portal', description: 'Your training progress, schedule, flights, and finances.', position: 'right' },
      { target: '[data-testid="help-fab"]', title: 'Page Help', description: 'Need help? Click this button on any page.', position: 'left' },
    ],
    partner_admin: [
      { target: 'aside nav', title: 'Partner Portal', description: 'View your Training Services Agreement, confirm payment receipts, monitor flight debits, and request weekly schedules.', position: 'right' },
      { target: '[data-testid="help-fab"]', title: 'Page Help', description: 'Click for step-by-step partner workflow guidance.', position: 'left' },
    ],
    partner_instructor: [
      { target: 'aside nav', title: 'Partner Instructor', description: 'Same instructor tools as Sager — scoped to students assigned to your academy. Log flights, schedule, dispatch.', position: 'right' },
      { target: '[data-testid="help-fab"]', title: 'Page Help', description: 'Click for help anytime.', position: 'left' },
    ],
  },
  ar: {
    admin: [
      { target: '[data-testid="global-search"]', title: 'البحث السريع', description: 'ابحث في الطلاب والموظفين والبرامج والمزيد من أي مكان.', position: 'bottom' },
      { target: 'aside nav', title: 'القائمة الجانبية', description: 'الوصول إلى جميع الوحدات — منظمة حسب النظرة العامة، التدريب، المالية، والامتثال.', position: 'left' },
      { target: '[data-testid="help-fab"]', title: 'مساعدة الصفحة', description: 'كل صفحة لها زر مساعدة. انقر للحصول على إرشادات تفصيلية.', position: 'right' },
      { target: '[data-testid="notification-bell"]', title: 'الإشعارات', description: 'تنبيهات النظام والمواعيد النهائية والأحداث المهمة.', position: 'bottom' },
    ],
    finance: [
      { target: 'aside nav', title: 'المالية والمحاسبة', description: 'ابدأ من الرئيسية المالية لمتابعة النقد وأعمار الذمم والمستحقات الأسبوعية. القائمة مقسمة إلى مجموعات (المقبوضات، المدفوعات، دفتر الأستاذ، الضرائب، التقارير) — اضغط عنوان المجموعة لطيّها.', position: 'left' },
      { target: '[data-testid="global-search"]', title: 'البحث السريع', description: 'ابحث في الطلاب والموردين وأوامر الشراء من أي مكان.', position: 'bottom' },
      { target: '[data-testid="help-fab"]', title: 'مساعدة الصفحة', description: 'انقر للحصول على تعليمات تفصيلية في أي صفحة.', position: 'right' },
    ],
    instructor: [
      { target: 'aside nav', title: 'بوابة المعلم', description: 'سجّل الرحلات، أدر التوفر، واعرض طلبات الطيران.', position: 'left' },
      { target: '[data-testid="help-fab"]', title: 'مساعدة الصفحة', description: 'انقر هنا في أي وقت للمساعدة في الصفحة الحالية.', position: 'right' },
    ],
    student: [
      { target: 'aside nav', title: 'بوابة الطالب', description: 'تقدمك التدريبي، الجدول، الرحلات، والأمور المالية.', position: 'left' },
      { target: '[data-testid="help-fab"]', title: 'مساعدة الصفحة', description: 'تحتاج مساعدة؟ انقر هذا الزر في أي صفحة.', position: 'right' },
    ],
    partner_admin: [
      { target: 'aside nav', title: 'بوابة الشريك', description: 'اعرض اتفاقية الخدمات التدريبية، أكّد استلام المدفوعات، راقب خصومات الرحلات، واطلب جداول أسبوعية.', position: 'left' },
      { target: '[data-testid="help-fab"]', title: 'مساعدة الصفحة', description: 'انقر للحصول على إرشادات.', position: 'right' },
    ],
    partner_instructor: [
      { target: 'aside nav', title: 'معلم الشريك', description: 'نفس أدوات المعلم — مقصورة على الطلاب المسندين إلى أكاديميتك.', position: 'left' },
      { target: '[data-testid="help-fab"]', title: 'مساعدة الصفحة', description: 'انقر للحصول على المساعدة.', position: 'right' },
    ],
  },
};

const getTourSteps = () => {
  const lang = i18n.language?.startsWith('ar') ? 'ar' : 'en';
  return tourSteps[lang] || tourSteps.en;
};

export default getTourSteps;
